import { Header, Footer } from "../../../../../components";
import { Post } from "../../../../../modules/Post";

export const LectureInquiry = () => {
  return (
    <>
      <Header />
      <Post />
      <Footer />
    </>
  );
};
